import { Button } from "../../button";
import HeroTimeline from "./HeroTimeline";
import {
  FEATURED_SECTION_ID,
  SIGNUP_SECTION_ID,
  scrollToLandingSection,
} from "./scroll";

/**
 * What the app is, said once, beside a picture of it.
 *
 * The two halves are the same claim twice over — "all of time on one axis" in
 * words on the left, and eight centuries crossed in three rows on the right.
 */
export default function LandingHero() {
  return (
    <section className="grid items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14">
      <div>
        <p className="text-[10.5px] font-bold uppercase tracking-[.1em] text-muted-foreground">
          A timeline for everything
        </p>

        <h1
          className="mt-4 text-[40px] font-semibold leading-[1.08] tracking-[.005em] sm:text-[48px] lg:text-[54px]"
          style={{ fontFamily: "var(--font-serif)" }}
        >
          <span className="block text-foreground">Explore history.</span>
          <span className="block text-accent-foreground">Write your own.</span>
        </h1>

        <div className="mt-6 h-[2px] w-10 bg-primary" />

        <p className="mt-6 max-w-[52ch] text-[17px] leading-[1.65] text-ink2">
          Eventera puts every record on one time axis — from billion-year epochs
          down to a single second. Read the past that others have charted, then
          keep your own: journal entries, milestones, the day the car went in for
          service.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <Button
            size="lg"
            onClick={() => scrollToLandingSection(SIGNUP_SECTION_ID)}
          >
            Start your timeline
          </Button>
          <Button
            variant="ghost"
            size="lg"
            onClick={() => scrollToLandingSection(FEATURED_SECTION_ID)}
          >
            Browse featured spaces
          </Button>
        </div>
      </div>

      <HeroTimeline />
    </section>
  );
}
